<template>
  <Popup v-model:show="popupShow" title="取消原因" height="70%" :round="true">
    <div class="h-full bg-white px-15">
      <div class="text-16 text-default h-50 leading-50">取消原因<i class="text-required">*</i></div>
      <van-field
        class="rounded-2 text-14"
        style="border:1px solid #E1E3E5"
        v-model="opt_content"
        rows="4"
        type="textarea"
        maxlength="200"
        placeholder="请填写取消原因"
      />
    </div>
    <FooterButton okText="提交" :showCancel="false" @submit="handleSubmit" />
  </Popup>
</template>
<script setup>
import Popup from "@/components/PopupPicker/Popup.vue";
import { useVModel } from "@vueuse/core";
import { FooterButton } from "@/components/FormView/index";
import { ref } from "vue";
import { repairService } from "@/service";
import { useRoute } from "vue-router";
import { Toast } from "vant";
import to from "await-to-js";

const props = defineProps({
  modelValue: { default: false },
  list: { default: () => [] }
});
const emit = defineEmits(["update:modelValue", "refresh"]);
const popupShow = useVModel(props, "modelValue", emit);

const opt_content = ref("");
const route = useRoute();

const handleSubmit = async () => {
  if (!opt_content.value) return Toast.fail("必填项不可为空");
  const [err] = await to(
    repairService.closeWorkOrder({
      workorder_id: route.query.id,
      close_notes: opt_content.value
    })
  );

  if (err) return;

  Toast.success("操作成功");

  emit("refresh");

  popupShow.value = false;
};
</script>
